module.exports = __webpack_public_path__ + "img/365.9ac5bfbe.png";